import { FilteringItem } from '@3ddv/ngx-sites-builder-lib';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilteringItemPosition } from '../../models/filtersUtils.model';

@Component({
  selector: 'app-filter-previewitem',
  templateUrl: './filter-previewitem.component.html',
  styleUrls: ['./filter-previewitem.component.scss'],
})
export class FilterPreviewItemComponent implements OnDestroy {
  @Input() list: Array<FilteringItem>;
  @Input() public activeId: string;

  @Output() editedItem = new EventEmitter<FilteringItem>();
  @Output() updatedPositionItem = new EventEmitter<FilteringItemPosition>();
  private subscriptions: Array<Subscription> = [];

  constructor(public changeDetector: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public editItem(item: FilteringItem) {
    this.activeId = item.id;
    this.editedItem.emit(item);
  }

  public moveItem(position, action, id) {
    this.updatedPositionItem.emit({ currentPosition: position, action: action, id: id });
  }

  public moveItemFromChild($event_move) {
    this.updatedPositionItem.emit($event_move);
  }
}
